import { render, staticRenderFns } from "./StaffHistory.vue?vue&type=template&id=41923254&scoped=true"
import script from "./StaffHistory.vue?vue&type=script&lang=js"
export * from "./StaffHistory.vue?vue&type=script&lang=js"
import style0 from "./StaffHistory.vue?vue&type=style&index=0&id=41923254&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "41923254",
  null
  
)

export default component.exports